"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newModeUrlPath = exports.shouldRedirectToMode = void 0;
/**
 * Determine whether we will allow the application to be launched in the current mode.
 * @param property
 * @param currentMode
 * @returns AppMode | void. If provided, the mode that the user should be redirected to.
 */
const shouldRedirectToMode = (property, currentMode) => {
    var _a;
    const propertyIsPublished = ((_a = property.published_version) !== null && _a !== void 0 ? _a : 0) >= 1;
    switch (currentMode) {
        case 'edit':
            if (!propertyIsPublished) {
                return 'add';
            }
            break;
        case 'onboard':
        case 'add':
            if (propertyIsPublished) {
                return 'edit';
            }
        default:
            break;
    }
};
exports.shouldRedirectToMode = shouldRedirectToMode;
/* Return an updated URL path to redirect to. */
const newModeUrlPath = (pathName, currentMode, nextMode) => {
    return pathName.replace(`/${currentMode}`, `/${nextMode}`);
};
exports.newModeUrlPath = newModeUrlPath;
//# sourceMappingURL=modeGuard.js.map